.info-message {
  display: flex;
  margin-top: 0.5rem;
}

.info-message__container {
  background-color: var(--color-uva-white);
  padding: 1.5rem;
}

.info-message__icon {
  color: var(--color-navy-600);
  margin-right: 0.25rem;
}
